<template>
    <v-container>
        <h1 class="text-center">Hello project detail {{ ProjectID }}</h1>
    </v-container>
</template>

<script>
import BotSpinner from "@/components/bot/spinner/bot.spinner.vue";
const cafe = {
    default: {
        sp: {
            snb: "views/snackbar/show",
        },
    },
    sms: {
        success: {
            update: "Cập nhật dự án thành công!",
        },
    },
};
const df = cafe.default;

export default {
    name: "project-detail",

    components: {
        "bot-spinner": BotSpinner,
    },

    // this is state
    data() {
        return {
            vld: this.$options.filters.validate,
            hlog: this.$options.filters.hlog,
            tgh: this.$options.filters.tgh,
            tufl: this.$options.filters.tufl,
            isValid: false,
            ProjectID: null,
            spinner: {
                visible: false,
                color: "red",
            },
        };
    },

    mounted() {
        const { id } = this.$route.params;
        this.ProjectID = id;
    },

    computed: {
        ua() {
            return this.$store.state.useragent;
        },
    },

    methods: {
        async submit() {
            const { form } = this.$refs;
            if (!form) return;
            this.isValid = form.validate();
            if (!this.isValid) return;
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped></style>



// WEBPACK FOOTER //
// project.detail.vue